<template>
  <div class="title">
    <div class="container">
      <BaseTextAnimation2 class="name-label" ref="alias" v-show="opponent.alias">
        <BaseOpponentLabel :class="[unlocked ? 'unlocked' : 'locked']" :opponent-label="opponent.alias"/>
      </BaseTextAnimation2>
      <BaseTextAnimation3 ref="name" class="name">
        <BaseText3 :text="formattedName"/>
      </BaseTextAnimation3>
    </div>
    <div class="button" @click="$emit('button-clicked')">
      <BaseText4 text="Stats"/>
      <BaseButtonExpand :state="state"/>
    </div>
  </div>
</template>

<script>
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText4 from '@/components/BaseText4/BaseText4'
import BaseOpponentLabel from '@/components/BaseOpponentLabel/BaseOpponentLabel'
import BaseTextAnimation2 from '@/components/BaseTextAnimation2/BaseTextAnimation2'
import BaseTextAnimation3 from '@/components/BaseTextAnimation3/BaseTextAnimation3'
import BaseButtonExpand from '@/components/BaseButtonExpand/BaseButtonExpand'
import { TimelineMax } from 'gsap'
export default {
  components: {
    BaseText3,
    BaseText4,
    BaseOpponentLabel,
    BaseTextAnimation2,
    BaseTextAnimation3,
    BaseButtonExpand
  },
  props: {
    state: {
      type: String,
      default: 'open'
    },
    opponent: {
      type: Object,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    this.tl = this.createTl()
  },
  computed: {
    formattedName () {
      return this.opponent.name.split(' ').join('<br>')
    }
  },
  methods: {
    createTl () {
      const tl = new TimelineMax({ paused: false })
      tl.add([
        this.$refs['name'].tl,
        this.$refs['alias'].tl
      ], 0, 'start', 0)
      return tl
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  position: relative;
}
.container {
  width: 100%;
  position: relative;
}
.name {
  width: 100%;
  text-align: left;
  overflow: hidden;
}
.locked {
  background: #999b9f;
}
.button {
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  .base-button-expand {
    margin-left: 0.5rem;
  }
}
</style>
